// extracted by mini-css-extract-plugin
export var quantityInput = "_ns-0";